var _ = require('underscore/underscore');

var Page = require('front/pages/Page/Page');

module.exports = Page.extend({
    $parent: function () {
        return this.parent.$content;
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Section/SubSection.js
// module id = 12
// module chunks = 0